import {Observable, zip as observableZip} from 'rxjs';

import {filter, first, publishLast, refCount} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {LogService} from '../log/log.service';
import {ThemeService} from "./theme.service";

@Injectable()
export class LoginInitializer implements Resolve<any> {
  private combinedObservable: Observable<any>;

  constructor(private themeService: ThemeService) {
		this.combinedObservable = observableZip(
			this.themeService.getTheme()
		).pipe(filter(x => undefined !== x), first(), publishLast(), refCount());
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.combinedObservable;
  }
}

